<!-- Update your template section for the grouped options -->
<mat-form-field appearance="outline" class="w-100" [subscriptSizing]="hideSubscript() ? 'dynamic' : undefined">
  <mat-label>{{ placeholder() }}</mat-label>
  <mat-select
    [value]="multiple() ? selectedValues : selectedOption"
    [ngModel]="multiple() ? selectedValues : selectedOption"
    (selectionChange)="onSelectionChange($event)"
    [formControl]="formControl"
    [multiple]="multiple()"
    panelClass="custom-select-panel"
  >
    <div class="search-input-container">
      <input
        type="text"
        placeholder="Search..."
        class="search-input"
        [(ngModel)]="searchQuery"
        (input)="filterRecords()"
        (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()"
      />
    </div>
    
    @if(multiple() && filteredRecords.length>0 && showSelectAll()){
      <app-select-all [model]="formControl" [values]="filteredRecords" (toggleCheckbox)="toggleCheckbox($event)">
      </app-select-all>
    }
    
    <!-- Only show "None" option when not in multiple selection mode -->
    @if(!multiple()){
      <mat-option>None</mat-option>
    }

    @if(!groupSelection()){
      @for(option of filteredRecords;track $index){
        <mat-option [value]="option[valueKey()] ? option[valueKey()]?.toString() : ''">
          {{ option[displayKey()] }}
          @if(this.showFavorite()){
          <mat-icon (click)="toggleFavorite(option, $event)">{{ option.is_favorite ? 'star' : 'star_border' }}</mat-icon>
          }
          @if(this.showTrash() && !option.default){
              <mat-icon (click)="deleteOption(option,$event)">delete</mat-icon>
          }
        </mat-option>
      }
    }
    @else{
      @for(option of filteredRecords;track $index){
        <!-- Custom group header instead of mat-optgroup label -->
        <div class="group-header" (click)="toggleGroup(option.group); $event.stopPropagation()">
          <span class="group-title">{{ option.group }}</span>
          <mat-icon class="toggle-icon">{{ expandedGroups[option.group] ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        
        <!-- Only show items if the group is expanded -->
        @if(expandedGroups[option.group]){
          @for (item of option.items; track item.id) {
            <mat-option [value]="returnFullObject() ? item : item[valueKey()]?.toString()" class="group-item">
              {{ item[displayKey()] }}
            </mat-option>
          }
        }
      }
    }

    @if(showAddView()){
      <mat-option (click)="addItem()" [value]="'create-new'" class="create-new-option">
        <em>Create New...</em>
      </mat-option>
    }
  </mat-select>
  
  @if(formControl?.hasError('required')){
    <mat-error>This field is required.</mat-error>
  }
  @if(showEditView() && (selectedOption && selectedOption.type ? selectedOption.type !== 'custom' : true)){
    <div class="edit-mode" (click)="viewItem()" >
      <mat-icon 
        [matTooltip]="viewTip()" 
        class="hover-effect">
        visibility
      </mat-icon>
    </div>
  }
</mat-form-field>